import { useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { removeQueryParameters } from '@ucheba/utils/helpers/router'
import { UzSectionsEnum } from '../types'
import { IUzSectionsNavigationItem, sectionsEventsNavigationItems } from '../constants'
import { isPaidPackage } from '../../../pages/uz/ssr/[id]/utils/isPaidPackage'

interface IUseNavigationData {
  activeIndex: number
  sections: IUzSectionsNavigationItem[]
}

export const useNavigation = (): IUseNavigationData => {
  const router = useRouter()
  const { asPath } = router

  const {
    id: institutionId,
    partnerCompanies,
    hasNews,
    hasOlympiads,
    hasPrograms,
    hasSubdivisions,
    members,
    hasArticles,
    paidPackage,
    companiesGraduateJobList,
  } = useSelector(institutionItemSelectors.currentInstitution)

  const sectionsItems = useCallback(() => {
    let list = sectionsEventsNavigationItems

    // Далее идет фильтрация от тех пунктов меню
    // по которым ничего нет в данном УЗ

    if (!hasOlympiads) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.olympiads)
    }

    if (!hasPrograms) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.programs)
    }

    if (!hasSubdivisions) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.units)
    }

    if (!members.length) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.teachers)
    }

    if (!partnerCompanies.length && !companiesGraduateJobList.length) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.career)
    }

    if (!hasArticles) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.articles)
    }

    // Далее фильтрация для тех УЗ
    // у которых нет платного пакета
    if (!isPaidPackage(paidPackage)) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.comments)
      list = list.filter(({ key }) => key !== UzSectionsEnum.news)
    } else if (!hasNews) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.news)
    }

    return list
  }, [
    hasArticles,
    hasNews,
    hasOlympiads,
    hasPrograms,
    hasSubdivisions,
    members.length,
    paidPackage,
    partnerCompanies.length,
    companiesGraduateJobList,
  ])

  const sectionsList = useMemo(() => sectionsItems(), [sectionsItems])

  const id = useMemo(() => {
    if (router.query.id) {
      return router.query.id
    }

    if (institutionId) {
      return institutionId
    }

    const arr = asPath.split('/')

    return arr[2]
  }, [asPath, institutionId, router.query.id])

  return useMemo(() => {
    const regex = /\/desktop|\/mobile|\/ssr/

    let activeIndex = sectionsList.findIndex((item) => {
      const path = removeQueryParameters(asPath).replace(regex, '')

      return item.key === path.split('/')[3]
    })

    if (activeIndex === -1) {
      activeIndex = 0
    }

    const sections = sectionsList.map((item) => {
      return {
        key: item.key,
        name: item.name,
        href: `/uz/${id}/${item.key}`,
      }
    })

    return {
      activeIndex,
      sections,
    }
  }, [sectionsList, asPath, id])
}
